<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="提现管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">Withdrawal Management</li>
        </ul>
      </template>
    </TitleCard>

    <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush" style="position: relative">
            <div class="card-body">
<!--              <div>-->
<!--                <el-input v-model="listParams.name"-->
<!--                          placeholder="提现姓名"-->
<!--                          size="small"-->
<!--                          clearable-->
<!--                          style="width: 10%;margin-left: 5px"-->
<!--                ></el-input>-->
<!--                <el-select v-model="listParams.status"-->
<!--                           placeholder="请选择状态"-->
<!--                           size="small"-->
<!--                           clearable-->
<!--                           style="width: 10%;margin-left: 5px"-->
<!--                >-->
<!--                  <el-option-->
<!--                      v-for="item in options"-->
<!--                      :key="item.value"-->
<!--                      :label="item.label"-->
<!--                      :value="item.value">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--                <el-date-picker-->
<!--                    clearable-->
<!--                    v-model="dateValue"-->
<!--                    end-placeholder="结束日期"-->
<!--                    range-separator="至"-->
<!--                    size="small"-->
<!--                    start-placeholder="开始日期"-->
<!--                    style="width: 23%;margin-left: 5px"-->
<!--                    type="daterange"-->
<!--                >-->
<!--                </el-date-picker>-->
<!--                <el-button round-->
<!--                           size="small"-->
<!--                           style="margin-left: 10px"-->
<!--                           type="primary"-->
<!--                           @click="getWithdrawalPageList"-->
<!--                >查 询-->
<!--                </el-button>-->
<!--                <el-button round-->
<!--                           size="small"-->
<!--                           style="margin-left: 10px"-->
<!--                           @click="clearParams"-->
<!--                >重 置-->
<!--                </el-button>-->
<!--              </div>-->
              <div style="display: flex;align-items: center">
                <div>类型 :</div>
                <el-radio-group v-model="listParams.type" style="margin-left: 20px" @input="getWithdrawalPageList">
                  <el-radio label="1">用户</el-radio>
                  <el-radio label="2">商家</el-radio>
                </el-radio-group>
              </div>
              <el-table
                  :data="tableData"
                  style="width: 100%">
                <el-table-column
                    label="编号"
                    prop="id"
                    width="80">
                </el-table-column>
<!--                <el-table-column-->
<!--                    label="提现姓名"-->
<!--                    prop="name"-->
<!--                    width="100">-->
<!--                </el-table-column>-->
                <el-table-column
                    label="提现金额">
                  <template #default="scope">
                    {{ scope.row.price | format }}
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="listParams.type == 2"
                    label="审核状态">
                  <template #default="scope" >
                    <el-tag v-if="scope.row.status == 0">待审核</el-tag>
                    <el-tag v-else-if="scope.row.status == 1" type="success">成功</el-tag>
                    <el-tag v-else-if="scope.row.status == 2" type="warning">失败</el-tag>
                    <el-tag v-else>待管理员处理</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="listParams.type == 1"
                    label="提现状态">
                  <template #default="scope" >
                    <el-tag v-if="scope.row.wxState === 'ACCEPTED'">转账已受理</el-tag>
                    <el-tag v-if="scope.row.wxState === 'WAIT_USER_CONFIRM'">待用户确认</el-tag>
                    <el-tag v-if="scope.row.wxState === 'PROCESSING'">转账锁定资金中</el-tag>
                    <el-tag v-if="scope.row.wxState === 'SUCCESS'" type="success">成功</el-tag>
                    <el-tag v-if="scope.row.wxState === 'FAIL'" type="warning">失败</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    v-if="listParams.type == 2"
                    label="提现状态">
                  <template #default="scope" >
                    <el-tag v-if="scope.row.wxState === 'PAYING'">支付中</el-tag>
                    <el-tag v-else-if="scope.row.wxState === 'SUCCESS'" type="success">成功</el-tag>
                    <el-tag v-else-if="scope.row.wxState === 'FAIL'" type="warning">失败</el-tag>
                    <el-tag v-else>待管理员处理</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    label="提现时间"
                    prop="createTime">
                </el-table-column>
                <el-table-column
                    label="处理时间"
                    prop="updateTime">
                </el-table-column>
                <el-table-column
                    v-if="listParams.type == 2"
                    label="操作">
                  <template #default="scope">
                    <el-button
                        v-if="scope.row.status == 0"
                        size="mini"
                        type="success"
                        @click="passOrReject(scope.row.id,1)"
                    >通过
                    </el-button>
                    <el-button
                        v-if="scope.row.status == 0"
                        size="mini"
                        type="danger"
                        @click="passOrReject(scope.row.id,2)"
                    >拒绝
                    </el-button>
                    <el-button
                        v-if="scope.row.status == 0"
                        size="mini"
                        type="success"
                        @click="openOrders(scope.row.bindOrderNoJson)"
                    >查看订单
                    </el-button>

                  </template>
                </el-table-column>
              </el-table>
              <div style="display: flex;justify-content: center;margin-top: 20px">
                <el-pagination
                    :current-page="listParams.current"
                    :page-size="listParams.size"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="tableDataTotal"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="商家提现订单号" :visible.sync="withdrawVisible" width="50%">
      <el-table :data="orders">
        <el-table-column label="订单号">
          <template slot-scope="scope">
            {{scope.row}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {mixins} from "@/views/withdrawalApplication/mixins";

export default {
  name: "withdrawalApplication",
  mixins: [mixins],
}
</script>

<style scoped>

</style>
